import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JobConfig } from '../models/job/job-config.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JobConfigService extends RequestService<JobConfig> {
  static PATH = '/om/job/config';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, JobConfigService.PATH, globalService.debugUrl);
  }
}
